const site = {
  siteConfig: (state) => state.base.siteConfig,
  isLogin: (state) => state.base.isLogin,
  loginUser: (state) => state.base.loginUser,
  isBuy: (state) => state.study.isBuy,
  umcId: (state) => state.study.umcId,
  defaultCid: (state) => state.study.defaultCid,
  courseId: (state) => state.study.courseId,
  courseSpecialId: (state) => state.study.courseSpecialId,
  productId: (state) => state.study.productId,
  courseCatalog: (state) => state.study.courseCatalog,
  reviewCatalog: (state) => state.study.reviewCatalog,
  reviewPositionName: (state) => state.study.reviewPositionName,
  videoId: (state) => state.study.videoId,
  buyType: (state) => state.study.buyType,
  catalogId: (state) => state.study.catalogId,
  pptId: (state) => state.study.pptId,
  exerId: (state) => state.study.exerId,
  userCourseList: (state) => state.study.userCourseList,
  playList: (state) => state.study.playList,
  srfId: (state) => state.study.srfId,
};
export default site;
